import api from '../auth';
const slug = 'api/jms/';

const JmService = () => {
    
    const getJms = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getJmsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getJm = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteJm = (id) => {
        return api
            .delete(slug + `jm/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createJm = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateJm = (id, data) => {
        return api.put(slug + `jm/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyJm = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getJms,
        getJmsLazy,
        getJm,
        deleteJm,
        createJm,
        updateJm,
        getOptions,
        copyJm
    };
};

export default JmService;
